import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { FilmImageSkeleton } from '../../image/subcomponents/skeleton';
import { FilmImageUI } from '../../image/subcomponents/ui';
import { FilmImageMediaType } from '../../image/types/media-type';
import { FilmWatchlistButton } from '../../watchlist-button/film-watchlist-button';
import { FilmThumbnailMediaType } from '../types/media-type';
const b = bemClassBuilder('v-film-thumbnail');
export const FilmThumbnailUI = observer(props => {
    const { film, config, cdnOptions, events } = props;
    const { mediaType, showWatchlistButton } = config;
    return (_jsxs("div", Object.assign({ className: b.block({ mediaType }) }, { children: [_jsx(FilmImageUI, { config: { mediaType: getFilmImageMediaType(config.mediaType) }, cdnOptions: { filmImage: cdnOptions }, film: film }), showWatchlistButton && (_jsx(FilmWatchlistButton, { displayText: {}, config: { iconOnly: true }, events: events }))] })));
});
FilmThumbnailUI.displayName = 'FilmThumbnailUI';
export const FilmThumbnailSkeleton = ({ mediaType }) => (_jsx(FilmImageSkeleton, { mediaType: getFilmImageMediaType(mediaType) }));
FilmThumbnailSkeleton.displayName = 'FilmThumbnailSkeleton';
const getFilmImageMediaType = (mediaType) => {
    switch (mediaType) {
        case FilmThumbnailMediaType.Backdrop:
            return FilmImageMediaType.Backdrop;
        case FilmThumbnailMediaType.Still:
            return FilmImageMediaType.Still;
        case FilmThumbnailMediaType.Poster:
        default:
            return FilmImageMediaType.Poster;
    }
};
